import { OnInit, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService, TranslationService, InitService, Product } from 'gast-common-ng';
// tslint:disable-next-line:max-line-length
import { AuthService, ServiceResponseDto, AuthOperation, ResponseType, CommonPortalUrlService, UrlParamService } from 'gast-portal-ng';
import { ShoppingCartService } from './shared/services/shopping-cart.service';
import { HeaderService } from './shared/services/header.service';
import { BookingStepService } from './shared/services/booking-step.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
var AppComponent = /** @class */ (function () {
    function AppComponent(initService, languageService, translationService, translateService, toastr, authService, router, route, shoppingCartService, headerService, urlParamService, commonPortalUrlService, bookingStepService, envConfig) {
        this.initService = initService;
        this.languageService = languageService;
        this.translationService = translationService;
        this.translateService = translateService;
        this.toastr = toastr;
        this.authService = authService;
        this.router = router;
        this.route = route;
        this.shoppingCartService = shoppingCartService;
        this.headerService = headerService;
        this.urlParamService = urlParamService;
        this.commonPortalUrlService = commonPortalUrlService;
        this.bookingStepService = bookingStepService;
        this.envConfig = envConfig;
        this.subscription = new Subscription();
        // tslint:disable:max-line-length
        // global configuration
        this.textAlignment = 'left';
        this.leadingColorCode = '#D63517';
        this.isDFH = false;
        this.showHeader = true;
        this.showLogin = true;
        this.duoUrl = 'https://www.deutsch-uni.com/';
        this.dfnUrl = environment.dfnEntryPoint;
        this.env = this.envConfig.callback(this.envConfig.value);
        this.footerModel = this.generateFooter();
        this.headerModel = this.generateHeaderModel(); // reinitialized after languages loaded and after language in translation service selected
        this.headerStyle = this.generateHeaderStyleModel();
        this.floatingContactPanelModel = this.generateFloatingContactPanelModel();
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        // initialize app
        this.initService.setProductId(Product.DUO);
        // handling session id in url
        var authParamSubscription = this.route.queryParamMap.subscribe(function (paramMap) {
            _this.urlParamService.saveSessionFromParamAndRemoveParam(paramMap);
            _this.authService.getUserInfo();
        });
        // callback for query parameter
        var urlParamSubscription = this.route.queryParams.subscribe(function (params) {
            // GAPTER-526 hide language dropdown for eks
            // TODO: remove once EKS has english texts
            if (params['code']) {
                var code = params['code'];
                if (code === 'DFH') {
                    _this.isDFH = true;
                }
                _this.bookingStepService.loadWebshopConfig(code);
            }
            if (params.lang) {
                _this.urlParamService.restoreUrlParams(params.lang);
            }
            // Service calls
            _this.languageService.loadLanguages();
        });
        // Subscriptions
        // GAPTER-526 hide language dropdown for eks
        // TODO: remove once EKS has english texts
        var configSubscription = this.bookingStepService.configLoaded.subscribe(function (config) {
            if (config && config.name.toLowerCase().includes('eks')) {
                // default lang for eks
                _this.changeLanguage('de');
                _this.headerStyle = _this.generateHeaderStyleModel(false);
            }
        });
        var logoutSubscription = this.authService.getAuthServiceResponse().pipe(filter(function (response) { return response instanceof ServiceResponseDto && response.operation === AuthOperation.Logout; }))
            .subscribe(function (response) {
            if (response.type === ResponseType.Success) {
                _this.router.navigate(['/course'], {
                    relativeTo: _this.route,
                    queryParams: { lang: _this.translationService.getCurrentLanguageCode().toLocaleLowerCase() },
                });
            }
            if (response.type === ResponseType.Error) {
                _this.toastr.error(_this.translateService.instant('GAST-COMMON-NG.GAST-ERROR-CODE.' + response.value.error.code));
            }
        });
        // subscribe to language change
        var languageChangedSubscription = this.translateService.onLangChange.subscribe(function (event) {
            _this.headerModel = _this.generateHeaderModel();
            _this.footerModel = _this.generateFooter();
            _this.floatingContactPanelModel = _this.generateFloatingContactPanelModel();
        });
        var languageLoadedSubscription = this.languageService.languagesLoaded.subscribe(function (languages) {
            _this.languages = languages;
            if (_this.isDFH) {
                if (_this.languages.filter(function (l) { return l.code === 'fr'; }).length === 0) {
                    var french = {
                        name: 'Français',
                        code: 'fr'
                    };
                    _this.languages.push(french);
                }
            }
            if (!_this.translateService.currentLang) {
                _this.translateService.currentLang = 'de';
            }
            _this.headerModel = _this.generateHeaderModel();
        });
        // subscribe to header visibility changes
        var headerVisibilitySubscription = this.headerService.showHeaderChanged.subscribe(function (showHeader) {
            setTimeout(function () {
                _this.showHeader = showHeader;
                if (!showHeader) {
                    _this.headerModel = null;
                }
            }, 0);
        });
        var headerLoginSubscription = this.headerService.showLoginChanged.subscribe(function (showLogin) {
            setTimeout(function () {
                _this.showLogin = showLogin;
                if (!showLogin) {
                    _this.headerStyle = _this.generateHeaderStyleModel(false, false);
                    _this.headerModel = _this.generateHeaderModel(false);
                }
            }, 0);
        });
        // add subs
        this.subscription.add(authParamSubscription);
        this.subscription.add(urlParamSubscription);
        this.subscription.add(configSubscription);
        this.subscription.add(logoutSubscription);
        this.subscription.add(languageChangedSubscription);
        this.subscription.add(languageLoadedSubscription);
        this.subscription.add(headerVisibilitySubscription);
        this.subscription.add(headerLoginSubscription);
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    // ********************** EVENT HANDLING **********************
    AppComponent.prototype.login = function () {
        var url = this.isBookingProcess()
            ? this.commonPortalUrlService.getPortalAccountLoginUrl(this.initService.getProductFromLocalStorage(), this.translationService)
            : this.commonPortalUrlService.getPortalAccountLoginUrl(this.initService.getProductFromLocalStorage(), this.translationService, this.env.duoLearnerPortalUrl);
        window.location.href = url;
    };
    AppComponent.prototype.isBookingProcess = function () {
        if (this.router.url.includes('code=') || this.router.url.includes('voucher=')) {
            return true;
        }
        return this.router.url !== '/course' && !this.router.url.includes('/course?') && !this.router.url.includes('/course/course-detail');
    };
    AppComponent.prototype.logout = function () {
        this.authService.logout();
        this.router.navigate(['/course'], { queryParamsHandling: 'merge' });
    };
    AppComponent.prototype.logoPressed = function () {
        window.location.href = "https://www.deutsch-uni.com/" + this.translationService.getCurrentLanguageCode() + "/";
    };
    AppComponent.prototype.onShoppingCartClicked = function () {
        // TODO: Refactor in DWS-1010
        var model = this.shoppingCartService.getShoppingCartModel();
        var isAuthorized = this.getUserModel() && this.getUserModel().username;
        if (model && model.selectedCourseId && model.selectedTimeScheduleId && isAuthorized) {
            this.router.navigate(['course/shopping-cart'], { queryParamsHandling: 'merge' });
        }
        else if (!isAuthorized) {
            this.toastr.info(this.translateService.instant('COMMON.SHOPPING_CARD_ACCESS'));
        }
        else {
            this.toastr.info(this.translateService.instant('COMMON.SHOPPING_CARD_EMPTY'));
        }
    };
    AppComponent.prototype.search = function (searchText) {
        console.log(searchText);
        alert(searchText);
    };
    /**
     * Change language and update current lang url parameter
     * @param languageCode
     */
    AppComponent.prototype.changeLanguage = function (languageCode) {
        this.translationService.changeLanguageUsingCode(languageCode);
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { lang: languageCode.toLocaleLowerCase() },
            queryParamsHandling: 'merge'
        });
    };
    AppComponent.prototype.subscribe = function (email) {
        console.log(email);
        alert(email);
    };
    // *********************** OTHER *****************************
    AppComponent.prototype.getUserModel = function () {
        var userDto = this.authService.readUserInfo();
        return userDto ? { username: userDto.username } : null;
    };
    // ***************** COMPONENT CONFIGURATION *****************
    AppComponent.prototype.generateHeaderModel = function (showNavItem) {
        if (showNavItem === void 0) { showNavItem = true; }
        if (showNavItem) {
            return {
                languageModels: this.languages ? this.languages.map(function (l) {
                    return { visibleText: l.name, code: l.code };
                }) : [],
                navigationTabUrls: [
                    { useTranslation: true, displayText: 'COMMON.HEADER.SEARCH', linkUrl: "" + this.duoUrl + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.SEARCH') + "/", iconClass: 'fal fa-search' },
                    { useTranslation: true, displayText: 'COMMON.HEADER.CONTACT', linkUrl: "" + this.duoUrl + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.CONTACT') + "/", iconClass: 'fal fa-envelope' }
                ],
                loginDropdownUrls: [
                    { useTranslation: true, text: 'COMMON.HEADER.MY_DUO', linkUrl: this.env.accountPortalUrl + "/login?product-id=4&lang=" + this.translateService.currentLang }
                ],
                loginDropdownProductUrls: [
                    { useTranslation: false, text: 'TestDaF', linkUrl: 'https://www.testdaf.de' },
                    { useTranslation: false, text: 'TestAS', linkUrl: 'https://www.testas.de' },
                    { useTranslation: false, text: 'onSET', linkUrl: 'https://www.onset.de' }
                ],
                logoBigUrl: 'portal-assets/img/duo_big.svg',
                logoSmallUrl: 'portal-assets/img/duo-logo-zeile.svg'
            };
        }
        else {
            return {
                languageModels: this.languages ? this.languages.map(function (l) {
                    return { visibleText: l.name, code: l.code };
                }) : [],
                navigationTabUrls: [],
                loginDropdownUrls: [
                    { useTranslation: true, text: 'COMMON.HEADER.MY_DUO', linkUrl: this.env.accountPortalUrl + "/login?product-id=4&lang=" + this.translateService.currentLang }
                ],
                loginDropdownProductUrls: [
                    { useTranslation: false, text: 'TestDaF', linkUrl: 'https://www.testdaf.de' },
                    { useTranslation: false, text: 'TestAS', linkUrl: 'https://www.testas.de' },
                    { useTranslation: false, text: 'onSET', linkUrl: 'https://www.onset.de' }
                ],
                logoBigUrl: 'portal-assets/img/duo_big.svg',
                logoSmallUrl: 'portal-assets/img/duo-logo-zeile.svg'
            };
        }
    };
    AppComponent.prototype.generateHeaderStyleModel = function (showLanguageDropdown, loginDropdownVisible) {
        if (showLanguageDropdown === void 0) { showLanguageDropdown = true; }
        if (loginDropdownVisible === void 0) { loginDropdownVisible = true; }
        var header = {
            languageDropdownVisible: showLanguageDropdown,
            loginDropdownVisible: loginDropdownVisible
        };
        return header;
    };
    // private generateFooter(): FooterModel {
    //   return {
    //     descriptionTitel: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.ABOUT_DUO.TITLE', useTranslation: true } as TextModel,
    //     descriptionText: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.ABOUT_DUO.TEXT', useTranslation: true } as TextModel,
    //     quickLinksTitle: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.TITLE', useTranslation: true } as TextModel,
    //     quickLinks: [
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.GERMAN_COURSES', useTranslation: true, linkUrl: `${this.duoUrl}deutschkurse/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.DUO_FOR_INSTITUTIONS', useTranslation: true, linkUrl: `${this.duoUrl}institutionen/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.LEARN_WITH_DUO', useTranslation: true, linkUrl: `${this.duoUrl}lernen-mit-duo/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.SELF_ASSESSMENT', useTranslation: true, linkUrl: `${this.duoUrl}selbsteinschaetzung/` } as LinkModel
    //     ],
    //     serviceLinksTitle: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.TITLE', useTranslation: true } as TextModel,
    //     serviceLinks: [
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.FAQ', useTranslation: true, linkUrl: `${this.duoUrl}faq/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.SYSTEM_REQUIREMENTS', useTranslation: true, linkUrl: `${this.duoUrl}systemvoraussetzungen/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.BROWSERCHECK', useTranslation: true, linkUrl: `${this.duoUrl}browsercheck` } as LinkModel
    //     ],
    //     contactLinksTitle: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.TITLE', useTranslation: true } as TextModel,
    //     contactLinks: [
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.YOUR_CONTACT_PERSON', useTranslation: true, linkUrl: `${this.duoUrl}ueber-duo/#c524` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.CONTACT', useTranslation: true, linkUrl: `${this.duoUrl}kontakt/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.IMPRINT', useTranslation: true, linkUrl: `${this.duoUrl}impressum/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.DATA_PROTECTION', useTranslation: true, linkUrl: `${this.duoUrl}datenschutz/` } as LinkModel,
    //       { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.CONDITIONS', useTranslation: true, linkUrl: `${this.duoUrl}agb/` } as LinkModel
    //     ],
    //     gastOfferText: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.GAST_OFFER_TEXT', useTranslation: true } as TextModel,
    //     facebookUrl: 'https://www.facebook.com/DeutschUniOnline/',
    //     youtubeUrl: 'https://www.youtube.com/user/DeutschUniOnline'
    //   } as FooterModel;
    // }
    AppComponent.prototype.generateFooter = function () {
        return {
            descriptionTitel: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.ABOUT_DUO.TITLE', useTranslation: true },
            descriptionText: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.ABOUT_DUO.TEXT', useTranslation: true },
            quickLinksTitle: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.TITLE', useTranslation: true },
            quickLinks: [
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.GERMAN_COURSES', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.GERMAN_COURSE') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.DUO_FOR_INSTITUTIONS', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.INSTITUTIONS') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.LEARN_WITH_DUO', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.LEARNING_WITH_DUO') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.QUICK_LINKS.SELF_ASSESSMENT', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.SELF_ASSESSMENT') + "/" }
            ],
            serviceLinksTitle: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.TITLE', useTranslation: true },
            serviceLinks: [
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.FAQ', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.FAQ') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.SYSTEM_REQUIREMENTS', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.SYSTEMREQUIREMENTS') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.BROWSERCHECK', useTranslation: true, linkUrl: "https://www.deutsch-uni.com/support/konfiguration/index?lang=" + this.translateService.currentLang }
            ],
            contactLinksTitle: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.TITLE', useTranslation: true },
            contactLinks: [
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.YOUR_CONTACT_PERSON', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.ABOUT_DUO') + "/#c524" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.CONTACT', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.CONTACT') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.IMPRINT', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.IMPRINT') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.DATA_PROTECTION', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.PRIVACY') + "/" },
                { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.CONDITIONS', useTranslation: true, linkUrl: "" + this.duoUrl + (this.translateService.currentLang === 'fr' ? 'de' : this.translateService.currentLang) + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.GTC') + "/" }
            ],
            gastOfferText: { text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.GAST_OFFER_TEXT', useTranslation: true },
            facebookUrl: 'https://www.facebook.com/DeutschUniOnline/',
            youtubeUrl: 'https://www.youtube.com/user/DeutschUniOnline'
        };
    };
    AppComponent.prototype.generateFloatingContactPanelModel = function () {
        return {
            contactImgTitle: { text: 'GAST-PORTAL-NG.FLOATING-CONTACT-PANEL.CONTACT_IMG_TEXT', useTranslation: true },
            contactLink: {
                linkUrl: "https://www.deutsch-uni.com/" + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.CONTACT') + "/",
                text: 'GAST-PORTAL-NG.FLOATING-CONTACT-PANEL.CONTACT_LINK_TEXT', useTranslation: true
            },
            emailIcon: 'fal fa-envelope',
            hiddentText: { text: 'COURSE.UPDATED_FLOATING_PANEL_TEXT', useTranslation: true },
            phoneIcon: 'fal fa-phone-volume',
            phoneNumberString: '+49 234 32 29 770'
        };
    };
    return AppComponent;
}());
export { AppComponent };
